// @flow

const React = require('react');
const PropTypes = require('prop-types');

export default (Component: React.ComponentType<*>) => {
  const ConfigWrapper = (props: {}, context: { config: {} }) => {
    return React.createElement(Component, {
      ...props,
      config: context.config,
    });
  };

  ConfigWrapper.contextTypes = {
    config: PropTypes.object,
  };
  ConfigWrapper.displayName = `withConfig(${Component.displayName ||
    Component.name})`;

  return ConfigWrapper;
};
